/** Quick Search "purchasing details" (Consignment invoice/BL) — independent on/off switches, one
 *  per piece, so any part of this can be turned off later without touching the component/template
 *  code. This data is traced through Transport Unit -> Consignment relationships that already
 *  exist for other reasons (see InventoryLotServiceImpl on the backend); it's inherently less
 *  reliable than the rest of Quick Search's data (a lot fed by several stock-in events can trace
 *  to several different Consignments, or none at all) — these flags are the intended way to dial
 *  any one piece back if it doesn't hold up in real use, without a redeploy-and-rewrite cycle.
 *
 *  The calculator itself is NOT gated by any of these — it works from a manually-typed price
 *  regardless, so it stays available even with every flag below off. */
export const QUICK_SEARCH_PURCHASING_FLAGS = {
  /** The whole price/invoice-amount line (Consignment's totalInvoiceAmount + currency). */
  showPriceInvoice: true,
  /** The Bill No / Bill of Lading No line. */
  showBlNumber: true,
  /** The "View Consignment" navigation link. */
  showConsignmentLink: true,
  /** A result spanning more than one Consignment gets "Mixed — tap for breakdown" (fetches the
   *  full per-Consignment list on demand). When off, a mixed result is simply left blank instead —
   *  no breakdown UI, less to go wrong. */
  showMixedBreakdown: true,
};
